import React from 'react';
import ShareableBadge from './ShareableBadge';
import './ShareModal.css';

const ShareModal = ({ isOpen, onClose, player, badge }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <ShareableBadge 
          player={{ name: player.name, totalVotesReceived: player.totalVotesReceived }}
          badge={{ title: badge.title, description: badge.description }}
        />
      </div>
    </div>
  );
};

export default ShareModal;
